import React from "react"
import { view } from "react-easy-state"
import { withRouter } from "react-router-dom"
import { Icon, Button, Modal, Upload, message } from "antd"

import { API, createUrl, getAuthorization } from "api"

import globalStore from "store"

class PaperRightSider extends React.Component {
  state = {
    solutionModalVisible: false,
    paperAttempted: false,
    viewEvaluation: false
  }

  componentDidMount() {
    const { paperAttempt } = this.props

    if (paperAttempt) {
      this.setState({
        paperAttempted: true,
        viewEvaluation: paperAttempt.evaluation_video_url
      })
    }
  }

  handleSubmitSolutionButton = () => {
    if (this.props.coursePaymentDone) {
      this.setState({ solutionModalVisible: true })
      return
    }

    const { courseId } = globalStore.ui.students.course_subscriptions.payment

    message.destroy()

    if (!courseId) {
      message.error("Course id is not valid to make payment.")
      return
    }
    globalStore.ui.students.papers.show = {}
    message.info(
      "You have not subscribed for this course. Redirecting to payment page..."
    )
    setTimeout(() => {
      this.props.history.push(`/courses/${courseId}/payment`)
    }, 2500)
  }

  closeSolutionModal = () => {
    this.setState({ solutionModalVisible: false })
  }

  submitSolution = () => {
    console.log("submitted")
  }

  handleDownloadPaperButton = () => {
    console.log("Paper downloaded")
    const paperUrl = this.props.paper.url
    // debugger
    const anchorTag = document.createElement("a")
    document.body.appendChild(anchorTag)
    anchorTag.download = true
    anchorTag.href = paperUrl
    anchorTag.click()
  }

  handleDownloadAnswerButton = () => {
    console.log("Answer downloaded")
    const paperUrl = this.props.paper.answer_sheet_pdf_url
    // debugger
    const anchorTag = document.createElement("a")
    document.body.appendChild(anchorTag)
    anchorTag.download = true
    anchorTag.href = paperUrl
    anchorTag.click()
  }

  handleViewEvaluationButton = () => {
    const { paperId } = this.props.match.params
    this.props.history.push(`/papers/${paperId}/evaluation`)
  }

  render() {
    const { solutionModalVisible, paperAttempted, viewEvaluation } = this.state

    const { paper } = this.props

    const paperId = paper.id

    const draggerProps = {
      name: "file",
      multiple: false,
      capture: true,
      headers: {
        Authorization: getAuthorization()
      },
      action: createUrl(
        process.env.REACT_APP_API_BASE_URL +
          API.students.papers.upload_attempt.url,
        { paperId }
      ),
      onChange: info => {
        const { status } = info.file
        if (status !== "uploading") {
          console.log(info.file, info.fileList)
        }
        if (status === "done") {
          message.destroy()
          message.success(`${info.file.name} file uploaded successfully.`)
          this.setState({ solutionModalVisible: false, paperAttempted: true })
        } else if (status === "error") {
          message.destroy()
          message.error(`${info.file.name} file upload failed.`)
        }
      }
    }
    console.log(this.props.paper)
    return (
      <React.Fragment>
        <div className="paper-sider">
          <Button
            size="large"
            block={true}
            onClick={this.handleDownloadPaperButton}
          >
            <Icon type="download" />
            Download Test
          </Button>
          {this.props.paper.answer_sheet_pdf_url ? (
            <Button
              size="large"
              block={true}
              onClick={this.handleDownloadAnswerButton}
            >
              <Icon type="download" />
              Download Answers
            </Button>
          ) : null}
          <Button
            type="primary"
            size="large"
            block={true}
            disabled={paperAttempted}
            onClick={this.handleSubmitSolutionButton}
          >
            <Icon type="upload" />
            Submit Solution
          </Button>
          <Button
            size="large"
            block={true}
            disabled={!viewEvaluation}
            onClick={this.handleViewEvaluationButton}
          >
            View Evaluation
          </Button>
          <p style={{ textAlign: "center" }}></p>
        </div>
        <Modal
          title="Submit Solution"
          visible={solutionModalVisible}
          onOk={this.submitSolution}
          onCancel={this.closeSolutionModal}
        >
          <Upload.Dragger {...draggerProps}>
            <p className="ant-upload-drag-icon">
              <Icon type="inbox" />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for a single upload. Strictly prohibit from uploading
              company data or other band files
            </p>
          </Upload.Dragger>
        </Modal>
      </React.Fragment>
    )
  }
}

export default withRouter(view(PaperRightSider))
